import { render } from "./DeclarabilityOverviewComponent.vue?vue&type=template&id=5f910740"
import script from "./DeclarabilityOverviewComponent.vue?vue&type=script&lang=js"
export * from "./DeclarabilityOverviewComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jellevanoosterbosch/PhpstormProjects/haaer/haaer-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__